import { ReferenceDataConstants } from '../../../constants/reference-data-constants';
import { BaseAdvancedFilterOptions } from './base-advanced-filter-options.model';

export class ApplicationCaseAdvancedFilterOptions extends BaseAdvancedFilterOptions {
  public LastDays?: number;
  public CaseStatuses: string;
  public DateRangeColumn = ReferenceDataConstants.DataRangePreSelectedOption;
  public ShowOnlyAlertedCases: boolean;
  public ShowOnlyBusinessWriterCases: boolean;
  public ShowOnlyCaseAdministratorCases: boolean;
  public ShowOnlyOfflineCases: boolean;
  public ShowOnlyCasesAcceptedWithoutAipCertificate: boolean;
  public ExcludeSelfEmployed: boolean;
  public ExcludeInterestOnly: boolean;
  public Scoreband: string;
  public TransactRules: string;
  public LoanGroups: string;
  public LoanTypes: string;
  public MinLTV?: number;
  public MaxLTV?: number;
  public MinLoan?: number;
  public MaxLoan?: number;
  public Owner: string;
  public ShowOnlyDocumentAlertedCases: boolean;
  public AdviceOwner: string;
  public AdviceTeam: string;
  public IsAdviceOwnerUnallocated: boolean;
  public AdviceStatuses: string;
  public ServiceLevels: string;
  public PackagingStages: string;
  public ShowOnlyCasesMarkedStagedPayment: boolean;
  public OfferDistributionChannel: string;
  public OnlineOfferStatuses: string;
}
